import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a0fa564&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=0a0fa564&prod&scoped=true&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=0a0fa564&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0fa564",
  null
  
)

export default component.exports